/**
 * Table stacking order (bottom to top). All values below MUI drawer (1200) and modal (1300).
 *
 * - Table body: default (0)
 * - Tooltip on table: TOOLTIP_ON_TABLE_Z_INDEX — visible on table, hidden behind sticky header
 * - Sticky column/header: STICKY_COLUMN_Z_INDEX — on top of tooltips, below dialogs/drawers
 */
export var TOOLTIP_ON_TABLE_Z_INDEX = 100;
export var STICKY_COLUMN_Z_INDEX = 1100;

/**
 * Shared styles for sticky first column with drop shadow effect
 */
export var stickyColumnShadowStyles = {
  "&::after": {
    content: '""',
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    width: "6px",
    transform: "translateX(100%)",
    background: "linear-gradient(to right, rgba(0, 0, 0, 0.07), rgba(0, 0, 0, 0))",
    pointerEvents: "none"
  }
};